export default __webpack_public_path__ + "assets/58b994b99be1c4f74bcf9955660cfd9a/amenities-04.jpg";